// extracted by mini-css-extract-plugin
export var Contact = "contact-module--Contact--LZ9Nt";
export var BigText = "contact-module--BigText--U6Tmf";